import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiHelper } from "../../../utils/apiHelper";
import { toast } from "react-toastify";

export const fetchRisks = createAsyncThunk(
    "risk/fetchRisks",
    async (startupId, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.get(`/startup/${startupId}/risks`);
            if (response.data.code === "00000") {
                return response.data.startupRisks;
            }
            throw new Error("Failed to fetch risks");
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const updateRisk = createAsyncThunk(
    "risk/updateRisk",
    async (riskData, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.put("/startup/risks", riskData);
            if (response.data.code === "00000") {
                toast.success('Risk bilgileri başarıyla güncellendi');
                return riskData;
            }
            throw new Error("Failed to update risk");
        } catch (error) {
            toast.error('Risk bilgileri güncellenirken bir hata oluştu');
            return rejectWithValue(error.message);
        }
    }
);

const riskSlice = createSlice({
    name: "risk",
    initialState: {
        risksByType: {
            1: "", // Teknik Riskler
            2: "", // Finansal Riskler
            3: "", // Operasyonel Riskler
            4: ""  // Diğer Riskler
        },
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchRisks.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchRisks.fulfilled, (state, action) => {
                state.loading = false;
                // Group risks by type
                action.payload.forEach(risk => {
                    state.risksByType[risk.riskType] = risk.description;
                });
            })
            .addCase(fetchRisks.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateRisk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateRisk.fulfilled, (state, action) => {
                state.loading = false;
                const { riskType, description } = action.payload;
                state.risksByType[riskType] = description;
            })
            .addCase(updateRisk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default riskSlice.reducer; 